import script from './SbPasswordStrengthMeter.vue_rollup-plugin-vue=script.js';
import normalizeComponent from '../../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import createInjector from '../../../node_modules/vue-runtime-helpers/dist/inject-style/browser.mjs.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sb-password-strength-meter"},[_c('div',{staticClass:"sb-password-strength-meter__wrapper"},[_c('div',{staticClass:"sb-password-strength-meter__fill",class:_vm.parsedPasswordStrength.meterStyle})]),_vm._v(" "),_c('div',{staticClass:"sb-password-strength-meter__message"},[_vm._v("\n    "+_vm._s(_vm.$t(_vm.parsedPasswordStrength.message))+"\n  ")])])};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-4669972c_0", { source: ".sb-password-strength-meter[data-v-4669972c]{--sb-password-strength-meter__wrapper__background-color:#d5d5d5;--sb-password-strength-meter__fill--weak__background-color:#ef8a00;--sb-password-strength-meter__fill--good__background-color:#429826;--sb-password-strength-meter__fill--error__background-color:#ea060a}.sb-password-error-meter[data-v-4669972c]{--sb-password-error-meter__wrapper__background-color:#d5d5d5;--sb-password-error-meter__fill__background-color:#ea060a}.sb-password-strength-meter[data-v-4669972c]{width:100%;margin-top:8px}.sb-password-strength-meter__message[data-v-4669972c]{margin-top:4px}.sb-password-strength-meter__wrapper[data-v-4669972c]{height:3px;border-radius:20px;background-color:var(--sb-password-strength-meter__wrapper__background-color)}.sb-password-strength-meter__fill[data-v-4669972c]{width:100%;height:100%;border-radius:inherit}.sb-password-strength-meter__fill--weak[data-v-4669972c]{background-color:var(--sb-password-strength-meter__fill--weak__background-color)}.sb-password-strength-meter__fill--good[data-v-4669972c]{background-color:var(--sb-password-strength-meter__fill--good__background-color)}.sb-password-strength-meter__fill--strong[data-v-4669972c]{background-color:var(--sb-password-strength-meter__fill--good__background-color)}.sb-password-strength-meter__fill--error[data-v-4669972c]{background-color:var(--sb-password-strength-meter__fill--error__background-color)}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-4669972c";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    createInjector,
    undefined,
    undefined
  );

export default __vue_component__;
